import React, { useState } from "react";
import { Mail, Check } from "lucide-react";
import { api } from "../lib/api";
import { useCart } from "../context/CartContext";
import { useAuth } from "../context/AuthContext";
import { toast } from "sonner";

const GUEST_EMAIL_KEY = "taven_guest_email";
export const getGuestEmail = () => { try { return localStorage.getItem(GUEST_EMAIL_KEY) || ""; } catch { return ""; } };
const valid = (e) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(e);

// Lightweight, 100% TAVEN-branded email capture for guest carts.
// Wires to /api/cart/track so we can send an abandoned-cart reminder from
// support@taven.store. No third-party branding is ever shown.
export const GuestEmailCapture = () => {
  const { user } = useAuth();
  const { items, subtotal } = useCart();
  const [email, setEmail] = useState(getGuestEmail());
  const [saved, setSaved] = useState(!!getGuestEmail());

  if (user) return null; // signed-in carts are tracked automatically

  const save = async (e) => {
    e.preventDefault();
    if (!valid(email)) { toast.error("Please enter a valid email address."); return; }
    try {
      await api.post("/cart/track", {
        email,
        items: items.map((i) => ({ handle: i.handle, title: i.title, image: i.image, price: i.price, quantity: i.quantity })),
        subtotal,
      });
      localStorage.setItem(GUEST_EMAIL_KEY, email);
      setSaved(true);
      toast.success("Saved. We'll hold your cart and email you if you don't finish.");
    } catch { toast.error("Could not save right now. Please try again."); }
  };

  if (saved) return (
    <div className="border border-taven-gold/40 bg-taven-gold/5 p-4 flex items-center gap-3" data-testid="guest-email-saved">
      <Check className="w-5 h-5 text-taven-gold shrink-0" />
      <p className="text-sm text-muted-foreground">Your cart is saved to <span className="font-semibold text-black">{email}</span>. We'll send a friendly reminder if you don't check out.</p>
    </div>
  );

  return (
    <form onSubmit={save} className="border border-black/10 bg-white p-4" data-testid="guest-email-capture">
      <div className="flex items-center gap-2 mb-2"><Mail className="w-4 h-4 text-taven-gold" /><p className="text-sm font-bold">Save your cart</p></div>
      <p className="text-xs text-muted-foreground mb-3">Enter your email and we'll hold your items and send a gentle reminder — no spam, ever. Support: support@taven.store</p>
      <div className="flex flex-col sm:flex-row gap-2">
        <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="you@email.com" data-testid="guest-email-input"
          className="flex-1 border border-black/15 px-3 py-2.5 text-sm outline-none focus:border-taven-gold" />
        <button type="submit" data-testid="guest-email-submit" className="bg-taven-black text-white font-bold uppercase tracking-wider text-xs px-5 py-2.5 hover:bg-taven-orange transition-colors">Save Cart</button>
      </div>
    </form>
  );
};

export default GuestEmailCapture;
